import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { APPLICATION_SUBDOMAIN } from '../../../constants';
import { useLoggedIn } from '../../../hooks/apollo/useLoggedIn';
import { locationToRedirectAfterLoginVar } from '../../../lib/apollo/cache';

// eslint-disable-next-line react/prop-types
export const PublicRedirectRoute = ({ children, ...rest }) => {
    const isLoggedIn = useLoggedIn();
    const locationToRedirectAfterLogin = useReactiveVar(locationToRedirectAfterLoginVar);

    return (
        <Route
            {...rest}
            render={() =>
                isLoggedIn ? (
                    <Redirect
                        push
                        to={!locationToRedirectAfterLogin ? `/${APPLICATION_SUBDOMAIN}/` : locationToRedirectAfterLogin}
                    />
                ) : (
                    children
                )
            }
        />
    );
};
